const factionIcons = {
    Federation: "Faction_FED25.png",
    "Klingon Empire": "Faction_KDF.png",
    "Romulan Republic": "Faction_Romulan_republic.png",
    "Cross-Faction": "Faction_Khitomer.png",
    Dominion: "Faction_Dominion.png",
};

const currencyIcons = {
    LC: "Lobi_Crystal_icon.png",
    Zen: "120px-Zen_icon.png",
    Dil: "Dilithium_icon.png",
    dil: "Dilithium_icon.png",
    "R&D": "Special_Requisition_Choice_Pack_-_Tier_6_Promotional_Ship_Choice_Pack_icon.png",
    MR: "",
    LB: "120px-Generic_Lock_Box_v2.png",
    EC: "Energy_credit.png",
    FC: "Fleet_Credit_icon.png",
    FSM: "Fleet_Ship_Module_icon.png",
    Veteran: "Starfleet_Veteran_icon.png",
    APP: "Appointment_Progress_icon.png",
    PPP5: "Epic_Prize_Token_-_Phoenix_Prize_Pack_icon.png",
    RSDOP: "Romulan_Survivor_Duty_Officer_Pack_icon.png",
    GQDOC: "Gamma_Quadrant_Duty_Officer_Cadre_icon.png",

    SRFEDS: "SRTOSS.png",
    SRTOSS: "SRTOSS.png",

    SRFED2: "SRFED2.png",
    SRFED3: "SRFED3.png",
    SRFED4: "SRFED4.png",
    SRFED5: "SRFED5.png",
    SRFED6: "SRFED5.png",

    SRKDF2: "SRKDF2.png",
    SRKDF3: "SRKDF3.png",
    SRKDF4: "SRKDF4.png",
    SRKDF5: "SRKDF5.png",
    SRKDF6: "SRKDF5.png",

    SRROM2: "SRFED2.png",
    SRROM3: "SRFED3.png",
    SRROM4: "SRFED4.png",
    SRROM5: "SRFED5.png",
    SRROM6: "SRFED5.png",
};

const tiers = {
    1: "I",
    2: "II",
    3: "III",
    4: "IV",
    5: "V",
    6: "VI",
};

const ranks = {
    1: "ens",
    2: "lt",
    3: "ltcmdr",
    4: "cmdr",
};

const professions = {
    1: "univ",
    2: "eng",
    3: "sci",
    4: "tac",
};

const specializations = {
    2: "int",
    3: "pilot",
    5: "cmd",
    6: "temporaloperative",
    8: "miracle",
};

const rankTexts = {
    1: "Ensign",
    2: "Lieutenant",
    3: "Lt. Commander",
    4: "Commander",
};

const professionText = {
    1: "Universal",
    2: "Engineering",
    3: "Science",
    4: "Tactical",
};

const specializationText = {
    2: "Intelligence Officer",
    3: "Pilot",
    5: "Command Officer",
    6: "Temporal Operative",
    8: "Miracle Worker",
};

const INITIAL_STATE = {
    name: "",
    faction: "",
    currency: [],
    can_dual_cannons: false,
    can_experimental_weapon: false,
    can_secondary_deflector: false,
    bridge_officers: [],
    hanger_bays: null,
    type: [],
    abilities: [],
    admiral_ability: "",
    tier: "",
    released_after: null,
    released_before: null
};

export {
    factionIcons,
    tiers,
    ranks,
    professions,
    specializations,
    rankTexts,
    professionText,
    specializationText,
    currencyIcons,
    INITIAL_STATE,
};
